module.exports = __webpack_public_path__ + "static/00010.b11afd28.jpg";